export default {
  index: [
    {
      path: '/gworder',
      component: resolve => require(['./gw_orderIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/gw_order/_router.js